const slugify = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

class AyaTreatmentGrid extends HTMLElement {
  connectedCallback() {
    this.filters = Array.from(this.querySelectorAll('.aya-treatment-grid__filter'));
    this.cards = Array.from(this.querySelectorAll('.aya-treatment-card'));
    this.dots = this.querySelector('.aya-treatment-grid__dots');
    this.perPage = parseInt(this.dataset.perPage, 10) || 4;
    this.page = 0;

    this.filters.forEach((button) => {
      button.addEventListener('click', () => {
        this.selectCategory(button);
        this.syncUrl(button);
      });
    });

    // Deep link: when the section sets data-url-param (the location grid uses
    // "region"), `?region=new-york` opens that tab. Matching is by slug, so
    // "new-york", "New York" and "new york" all select the "New York" tab.
    this.urlParam = this.dataset.urlParam;
    const requested = this.urlParam ? new URL(window.location.href).searchParams.get(this.urlParam) : null;
    const linked = requested
      ? this.filters.find((button) => slugify(button.dataset.category) === slugify(requested))
      : null;

    const initial =
      linked || this.filters.find((button) => button.classList.contains('is-active')) || this.filters[0];
    this.selectCategory(initial);
  }

  selectCategory(button) {
    if (!button) {
      this.visibleCards = this.cards;
      this.page = 0;
      this.render();
      return;
    }

    this.filters.forEach((filter) => {
      const isActive = filter === button;
      filter.classList.toggle('is-active', isActive);
      filter.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const category = button.dataset.category;
    this.visibleCards = this.cards.filter((card) => {
      const cardCategories = (card.dataset.categories || '').split('|').filter(Boolean);
      return cardCategories.includes(category);
    });
    this.page = 0;
    this.render();
  }

  // Keep the address bar on the selected tab so it can be shared or bookmarked.
  syncUrl(button) {
    if (!this.urlParam) return;
    const url = new URL(window.location.href);
    if (button === this.filters[0]) {
      url.searchParams.delete(this.urlParam);
    } else {
      url.searchParams.set(this.urlParam, slugify(button.dataset.category));
    }
    window.history.replaceState(window.history.state, '', url);
  }

  render() {
    this.cards.forEach((card) => {
      card.hidden = true;
    });

    const start = this.page * this.perPage;
    this.visibleCards.slice(start, start + this.perPage).forEach((card) => {
      card.hidden = false;
    });

    this.renderDots();
  }

  renderDots() {
    if (!this.dots) return;

    const pageCount = Math.max(1, Math.ceil(this.visibleCards.length / this.perPage));
    this.dots.innerHTML = '';
    this.dots.hidden = pageCount <= 1;

    for (let i = 0; i < pageCount; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `aya-treatment-grid__dot${i === this.page ? ' is-active' : ''}`;
      dot.setAttribute('aria-label', `Show treatments page ${i + 1}`);
      dot.addEventListener('click', () => {
        this.page = i;
        this.render();
      });
      this.dots.appendChild(dot);
    }
  }
}

customElements.define('aya-treatment-grid', AyaTreatmentGrid);
